import { Info, Snowflake } from "@phosphor-icons/react";

import RenderIf from "common/components/RenderIf";
import { Tag } from "common/components/ui/Tag";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import useCooldownState from "common/datahooks/useCooldownState";

import DetailItem from "./DetailItem";

interface CooldownRowProps {
  accountId: string;
}

export default function CooldownRow({ accountId }: CooldownRowProps) {
  const { cooldownState, isLoadingCooldownState } = useCooldownState(accountId);

  const hasActiveCooldown =
    !isLoadingCooldownState &&
    (cooldownState?.connect || cooldownState?.inmail);

  return (
    <RenderIf condition={hasActiveCooldown}>
      <DetailItem
        label="Cooldown"
        icon={<Snowflake weight="fill" />}
        tooltip={
          <Tooltip>
            <TooltipTrigger>
              <Info weight="fill" size={16} className="fill-black-300" />
            </TooltipTrigger>

            <TooltipContent>
              Accounts enter a "Cooldown" state whenever they cannot execute an
              interaction because of LinkedIn's limits. These limits reset
              weekly for Connection requests and monthly for InMails.
            </TooltipContent>
          </Tooltip>
        }
      >
        <div className="flex flex-row gap-2">
          <RenderIf condition={cooldownState?.connect}>
            <Tag variant="tertiary" size="md">
              Connect
            </Tag>
          </RenderIf>

          <RenderIf condition={cooldownState?.inmail}>
            <Tag variant="tertiary" size="md">
              InMail
            </Tag>
          </RenderIf>
        </div>
      </DetailItem>
    </RenderIf>
  );
}
